import React, { useState } from "react";
import { navigate } from "gatsby";
import { Formik, Form, Field } from "formik";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";

const SearchBar = () => {
  const [query, setQuery] = useState(null);

  const [showSearch, setShowForm] = useState(false);
  const toggleForm = () => {
    setShowForm(!showSearch);
    if (!showSearch) {
      setQuery(null);
    }
  };

  const handleSubmit = (values) => {
    const q = encodeURIComponent(values.query);
    navigate(`/search/?#gsc.tab=0&gsc.q=${q}`);
  };

  const searchField =
    "py-1 mr-3 transition-all duration-200 " +
    (showSearch
      ? "px-2 border rounded max-w-[175px]"
      : "bg-transparent max-w-[0px]");

  return (
    <div className="search inline-flex content-center items-center">
      <div className="flex flex-wrap">
        <div className="w-full">
          <Formik initialValues={{ query: "" }} onSubmit={handleSubmit}>
            <Form>
              <Field
                name="query"
                className={searchField}
                placeholder={`Type + Enter`}
              />
            </Form>
          </Formik>
        </div>
        {/* {showSearch && results.length > 0 &&
                    <div className='absolute w-1/2 max-w-full right-0 top-full mt-3 drop-shadow-md'>
                        <h2 className='bg-felt-500 text-white font-bold text-sm px-2 py-1'>{results.length} Result{results.length === 1 ? '' : 's'}</h2>
                        <ul className='bg-white text-xs border rounded-b-lg border-felt-500'>
                            {results.map(result => (
                                <li key={result.id} className='border-b border-felt-500 last:border-b-0'>
                                    <Link to={result.permalink} className='block px-2 py-1'>
                                        {result.title}
                                    </Link>
                                </li>
                            ))}
                        </ul>

                    </div>
                } */}
      </div>
      <FontAwesomeIcon icon={faSearch} onClick={toggleForm} />
    </div>
  );
};

export default SearchBar;
